import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import LogoCoordo from '../../Styles/Pictures/logo_coordogec.jpg';
import React from 'react';
import SocialNetwork from './SocialNetwork.js';
import ForgotPassForm from './ForgotPassForm';
import SendMailPass from './SendMailPass';

function ForgotPass({ match }) {
  const isReset = match.params.crypted !== undefined;

  return (
    <div className="lp-root">

      <aside className="lp-brand">
        <div className="lp-brand__grid" aria-hidden="true" />
        <div className="lp-brand__glow" aria-hidden="true" />

        <div className="lp-brand__body lp-brand__body--centered">

          <div className="lp-brand__headline">
            <span className="lp-brand__eyebrow">Sécurité du compte</span>
            <h1 className="lp-brand__name">
              Coordogec<em className="lp-brand__erp"> ERP</em>
            </h1>
            <p className="lp-brand__desc">
              {isReset
                ? 'Choisissez un nouveau mot de passe sécurisé pour votre compte.'
                : 'Saisissez votre adresse e-mail pour recevoir un lien de réinitialisation.'}
            </p>
          </div>

          <div className="lp-brand__security-badge">
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>Connexion chiffrée &amp; sécurisée</span>
          </div>
        </div>

        <footer className="lp-brand__footer">
          <SocialNetwork />
          <span className="lp-copyright">
            <FontAwesomeIcon icon={faCopyright} />
            {' '}Coordogec, {new Date().getFullYear()} — Tous droits réservés
          </span>
        </footer>
      </aside>

      <main className="lp-auth">
        <div className="lp-auth__inner">
          <div className="lp-auth__header">
            <div className="lp-brand__logo-wrap">
              <img src={LogoCoordo} alt="Coordogec" className="lp-brand__logo" />
            </div>
            <h2 className="lp-auth__title">
              {isReset ? 'Nouveau mot de passe' : 'Mot de passe oublié'}
            </h2>
            <p className="lp-auth__sub">
              {isReset
                ? 'Définissez votre nouveau mot de passe'
                : 'Nous vous enverrons un lien par e-mail'}
            </p>
          </div>

          {isReset
            ? <ForgotPassForm crypted={match.params.crypted} />
            : <SendMailPass />}
        </div>
      </main>

    </div>
  );
}

export default ForgotPass;
